module.exports = __webpack_public_path__ + "static/img/高空作业平台.409e690.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/高空作业平台.jpg
// module id = /221
// module chunks = 1